import { RouteDataService } from './route-data.service';
import { CommonService } from 'app/services/common.service';
import { CommonRouteFunctionService } from './common-routing-service';
import { CommonRequestResponseService } from './common-request-response.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class MenuService {

  currentRouteData: any;

  constructor(
    private router: Router,
    private routes: ActivatedRoute,
    private _commonDataSharedService: CommonDataSharedService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonRouteFunctionService: CommonRouteFunctionService,
    private _commonService: CommonService,
    private _routeDataService: RouteDataService
  ) { }

  selectMenu(menuArray, currentRoute) {
    this.currentRouteData = currentRoute;
    this._commonDataSharedService.toggleSideMenu.next();
    return;
  }

  dynamicMenuSelection(breadCrumbtext, path) {
    this._commonRouteFunctionService.breadCrumb.next(breadCrumbtext);
    const routerList = this._commonService.getDataWithoutObservable('routerList');
    for (let i = 0; i < routerList.length; i++) {

      if (routerList[i].path === 'home') {
        this.selectMenu(routerList, routerList[i]);
      }
    }

  }

  getMenuData(inputJson: any, menu: string) {

    this._commonRequestResponseService.post('shared/menu/get', inputJson).
      subscribe((data: Array<any>) => {

        switch (menu) {
          case 'coach': this._routeDataService.coachMenuRouteData.next(data['items']);
            this._routeDataService.setCoachMenuRoute.subscribe((path: string) => {
              this.router.navigate([path], { relativeTo: this.routes });
            });
            break;
          case 'parent': this._routeDataService.parentRouteData.next(data['items']);
            this._routeDataService.setParentMenuRoute.subscribe((path: string) => {
              this.router.navigate([path], { relativeTo: this.routes })
            });
            break;
          case 'student': this._routeDataService.studentRouteData.next(data['items']);
            localStorage.setItem('studentRouteData', JSON.stringify(data['items']));
            this._routeDataService.setStudentMenuRoute.subscribe((path: string) => {
              this.router.navigate([path], { relativeTo: this.routes })
            });
            break;
          default: this._routeDataService.adminMenuRouteData.next(data['items']);
            this._routeDataService.setAdminMenuRoute.subscribe((path: string) => {
              this.router.navigate([path], { relativeTo: this.routes });
            });
            break;
        }
      });
  }


  getCurrentPageId() {
    if (!this.currentRouteData) {
      if (JSON.parse(localStorage.getItem('currentPageData'))) {
        this.currentRouteData = JSON.parse(localStorage.getItem('currentPageData'));
      }
    }

    return this.currentRouteData && this.currentRouteData.id; // JDO: testing for default
    // ? this.currentRouteData.id : 0

  }

  setCurrentRouteData(routeData) {
    this.currentRouteData = routeData;
    localStorage.setItem('currentPageData', JSON.stringify(routeData));
  }
}
